module.exports = __webpack_public_path__ + "img/completado_b.30284a8f.png";